import {Equipe, Game, Match} from '@/models';
import playerStore from '@/stores/modules/player';

export class TATHelper {
	
	public static matchNJ(game: Game): void {
		const players = playerStore.state.players;
		const method = 'match'+players.length+'J';
		console.log('Create game with ', method);
		this['match'+players.length+'J'](game);
	}
	
	private static match2J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		
		const E1M1 = (new Equipe()).addPlayer(J1);
		const E2M1 = (new Equipe()).addPlayer(J2);
		M1.addEquipes([E1M1, E2M1]);
		
		const E1M2 = (new Equipe()).addPlayer(J1);
		const E2M2 = (new Equipe()).addPlayer(J2);
		M2.addEquipes([E1M2, E2M2]);
		
		const E1M3 = (new Equipe()).addPlayer(J1);
		const E2M3 = (new Equipe()).addPlayer(J2);
		M3.addEquipes([E1M3, E2M3]);
		
	}
	
	private static match3J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		const J3 = players[2];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		
		const E1M1 = (new Equipe()).addPlayer(J1);
		const E2M1 = (new Equipe()).addPlayer(J2);
		M1.addEquipes([E1M1, E2M1]);
		
		const E1M2 = (new Equipe()).addPlayer(J2);
		const E2M2 = (new Equipe()).addPlayer(J3);
		M2.addEquipes([E1M2, E2M2]);
		
		const E1M3 = (new Equipe()).addPlayer(J1);
		const E2M3 = (new Equipe()).addPlayer(J3);
		M3.addEquipes([E1M3, E2M3]);
	}
	
	private static match4J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		const J3 = players[2];
		const J4 = players[3];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		
		const E1M1 = (new Equipe()).addPlayer(J1);
		const E2M1 = (new Equipe()).addPlayer(J2);
		const E3M1 = (new Equipe()).addPlayer(J3);
		const E4M1 = (new Equipe()).addPlayer(J4);
		M1.addEquipes([E1M1, E2M1]);
		M1.addEquipes([E3M1, E4M1]);
		
		const E1M2 = (new Equipe()).addPlayer(J1);
		const E2M2 = (new Equipe()).addPlayer(J2);
		const E3M2 = (new Equipe()).addPlayer(J3);
		const E4M2 = (new Equipe()).addPlayer(J4);
		M2.addEquipes([E1M2, E4M2]);
		M2.addEquipes([E2M2, E3M2]);
		
		const E1M3 = (new Equipe()).addPlayer(J1);
		const E2M3 = (new Equipe()).addPlayer(J2);
		const E3M3 = (new Equipe()).addPlayer(J3);
		const E4M3 = (new Equipe()).addPlayer(J4);
		M3.addEquipes([E1M3, E3M3]);
		M3.addEquipes([E2M3, E4M3]);
	}
	
	private static match5J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		const J3 = players[2];
		const J4 = players[3];
		const J5 = players[4];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		const M4 = new Match(); game.addMatch(M4);
		const M5 = new Match(); game.addMatch(M5);
		
		const E1M1 = (new Equipe()).addPlayer(J1); // AB
		const E2M1 = (new Equipe()).addPlayer(J2);
		const E3M1 = (new Equipe()).addPlayer(J3); // CD
		const E4M1 = (new Equipe()).addPlayer(J4);
		M1.addEquipes([E1M1, E2M1]);
		M1.addEquipes([E3M1, E4M1]);
		// No 5
		
		const E1M2 = (new Equipe()).addPlayer(J1); // AE
		const E2M2 = (new Equipe()).addPlayer(J5);
		const E3M2 = (new Equipe()).addPlayer(J2); // BC
		const E4M2 = (new Equipe()).addPlayer(J3);
		M2.addEquipes([E1M2, E2M2]);
		M2.addEquipes([E3M2, E4M2]);
		// No 4
		
		const E1M3 = (new Equipe()).addPlayer(J5); // EB
		const E2M3 = (new Equipe()).addPlayer(J2);
		const E3M3 = (new Equipe()).addPlayer(J1); // AD
		const E4M3 = (new Equipe()).addPlayer(J4);
		M3.addEquipes([E1M3, E2M3]);
		M3.addEquipes([E3M3, E4M3]);
		// No 3
		
		const E1M4 = (new Equipe()).addPlayer(J1); // AC
		const E2M4 = (new Equipe()).addPlayer(J3);
		const E3M4 = (new Equipe()).addPlayer(J4); // DE
		const E4M4 = (new Equipe()).addPlayer(J5);
		M4.addEquipes([E1M4, E2M4]);
		M4.addEquipes([E3M4, E4M4]);
		// No 2
		
		const E1M5 = (new Equipe()).addPlayer(J2); // BD
		const E2M5 = (new Equipe()).addPlayer(J4);
		const E3M5 = (new Equipe()).addPlayer(J3); // CE
		const E4M5 = (new Equipe()).addPlayer(J5);
		M5.addEquipes([E1M5, E2M5]);
		M5.addEquipes([E3M5, E4M5]);
		// No 1
	}
	
	private static match6J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		const J3 = players[2];
		const J4 = players[3];
		const J5 = players[4];
		const J6 = players[5];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		
		const E1M1 = (new Equipe()).addPlayer(J1);
		const E2M1 = (new Equipe()).addPlayer(J2);
		const E3M1 = (new Equipe()).addPlayer(J3);
		const E4M1 = (new Equipe()).addPlayer(J4);
		const E5M1 = (new Equipe()).addPlayer(J5);
		const E6M1 = (new Equipe()).addPlayer(J6);
		M1.addEquipes([E1M1, E2M1]);
		M1.addEquipes([E3M1, E4M1]);
		M1.addEquipes([E5M1, E6M1]);
		
		const E1M2 = (new Equipe()).addPlayer(J1);
		const E2M2 = (new Equipe()).addPlayer(J2);
		const E3M2 = (new Equipe()).addPlayer(J3);
		const E4M2 = (new Equipe()).addPlayer(J4);
		const E5M2 = (new Equipe()).addPlayer(J5);
		const E6M2 = (new Equipe()).addPlayer(J6);
		M2.addEquipes([E6M2, E1M2]);
		M2.addEquipes([E2M2, E3M2]);
		M2.addEquipes([E4M2, E5M2]);
		
		const E1M3 = (new Equipe()).addPlayer(J1);
		const E2M3 = (new Equipe()).addPlayer(J2);
		const E3M3 = (new Equipe()).addPlayer(J3);
		const E4M3 = (new Equipe()).addPlayer(J4);
		const E5M3 = (new Equipe()).addPlayer(J5);
		const E6M3 = (new Equipe()).addPlayer(J6);
		M3.addEquipes([E6M3, E2M3]);
		M3.addEquipes([E3M3, E5M3]);
		M3.addEquipes([E1M3, E4M3]);
		
		console.log('GAME', game);
	}
	
	private static match7J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		const J3 = players[2];
		const J4 = players[3];
		const J5 = players[4];
		const J6 = players[5];
		const J7 = players[6];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		const M4 = new Match(); game.addMatch(M4);
		const M5 = new Match(); game.addMatch(M5);
		
		const E1M1 = (new Equipe()).addPlayer(J1); // AB
		const E2M1 = (new Equipe()).addPlayer(J2);
		const E3M1 = (new Equipe()).addPlayer(J3); // CD
		const E4M1 = (new Equipe()).addPlayer(J4);
		const E5M1 = (new Equipe()).addPlayer(J5); // EF
		const E6M1 = (new Equipe()).addPlayer(J6);
		M1.addEquipes([E1M1, E2M1]);
		M1.addEquipes([E3M1, E4M1]);
		M1.addEquipes([E5M1, E6M1]);
		// No G
		
		const E1M2 = (new Equipe()).addPlayer(J1); // AG
		const E2M2 = (new Equipe()).addPlayer(J7);
		const E3M2 = (new Equipe()).addPlayer(J2); // BC
		const E4M2 = (new Equipe()).addPlayer(J3);
		const E5M2 = (new Equipe()).addPlayer(J4); // DE
		const E6M2 = (new Equipe()).addPlayer(J5);
		M2.addEquipes([E1M2, E2M2]);
		M2.addEquipes([E3M2, E4M2]);
		M2.addEquipes([E5M2, E6M2]);
		// No F
		
		const E1M3 = (new Equipe()).addPlayer(J2); // BG
		const E2M3 = (new Equipe()).addPlayer(J7);
		const E3M3 = (new Equipe()).addPlayer(J1); // AC
		const E4M3 = (new Equipe()).addPlayer(J3);
		const E5M3 = (new Equipe()).addPlayer(J4); // DF
		const E6M3 = (new Equipe()).addPlayer(J6);
		M3.addEquipes([E1M3, E2M3]);
		M3.addEquipes([E3M3, E4M3]);
		M3.addEquipes([E5M3, E6M3]);
		// No E
		
		const E1M4 = (new Equipe()).addPlayer(J6); // FG
		const E2M4 = (new Equipe()).addPlayer(J7);
		const E3M4 = (new Equipe()).addPlayer(J1); // AE
		const E4M4 = (new Equipe()).addPlayer(J5);
		const E5M4 = (new Equipe()).addPlayer(J2); // BD
		const E6M4 = (new Equipe()).addPlayer(J4);
		M4.addEquipes([E1M4, E2M4]);
		M4.addEquipes([E3M4, E4M4]);
		M4.addEquipes([E5M4, E6M4]);
		// No C
		
		const E1M5 = (new Equipe()).addPlayer(J3); // CF
		const E2M5 = (new Equipe()).addPlayer(J6);
		const E3M5 = (new Equipe()).addPlayer(J5); // EG
		const E4M5 = (new Equipe()).addPlayer(J7);
		M5.addEquipes([E1M5, E2M5]);
		M5.addEquipes([E3M5, E4M5]);
		
	}
	
	private static match8J(game: Game): void {
		const players = playerStore.state.players;
		const fixe = game.equipeFixe;
		
		const J1 = players[0];
		const J2 = players[1];
		const J3 = players[2];
		const J4 = players[3];
		const J5 = players[4];
		const J6 = players[5];
		const J7 = players[6];
		const J8 = players[7];
		
		const M1 = new Match(); game.addMatch(M1);
		const M2 = new Match(); game.addMatch(M2);
		const M3 = new Match(); game.addMatch(M3);
		
		const E1M1 = (new Equipe()).addPlayer(J1); // AB
		const E2M1 = (new Equipe()).addPlayer(J2);
		const E3M1 = (new Equipe()).addPlayer(J3); // CD
		const E4M1 = (new Equipe()).addPlayer(J4);
		const E5M1 = (new Equipe()).addPlayer(J5); // DF
		const E6M1 = (new Equipe()).addPlayer(J6);
		const E7M1 = (new Equipe()).addPlayer(J7); // GH
		const E8M1 = (new Equipe()).addPlayer(J8);
		
		M1.addEquipes([E1M1, E2M1]);
		M1.addEquipes([E3M1, E4M1]);
		M1.addEquipes([E5M1, E6M1]);
		M1.addEquipes([E7M1, E8M1]);
		
		const E1M2 = (new Equipe()).addPlayer(J1); // AB
		const E2M2 = (new Equipe()).addPlayer(J2);
		const E3M2 = (new Equipe()).addPlayer(J3); // CD
		const E4M2 = (new Equipe()).addPlayer(J4);
		const E5M2 = (new Equipe()).addPlayer(J5); // DF
		const E6M2 = (new Equipe()).addPlayer(J6);
		const E7M2 = (new Equipe()).addPlayer(J7); // GH
		const E8M2 = (new Equipe()).addPlayer(J8);
		
		M2.addEquipes([E8M2, E1M2]);
		M2.addEquipes([E2M2, E3M2]);
		M2.addEquipes([E4M2, E5M2]);
		M2.addEquipes([E6M2, E7M2]);
		
		const E1M3 = (new Equipe()).addPlayer(J1); // AB
		const E2M3 = (new Equipe()).addPlayer(J2);
		const E3M3 = (new Equipe()).addPlayer(J3); // CD
		const E4M3 = (new Equipe()).addPlayer(J4);
		const E5M3 = (new Equipe()).addPlayer(J5); // DF
		const E6M3 = (new Equipe()).addPlayer(J6);
		const E7M3 = (new Equipe()).addPlayer(J7); // GH
		const E8M3 = (new Equipe()).addPlayer(J8);
		
		M3.addEquipes([E1M3, E5M3]);
		M3.addEquipes([E2M3, E6M3]);
		M3.addEquipes([E3M3, E7M3]);
		M3.addEquipes([E4M3, E8M3]);
	}
}